"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const index_1 = require("./index");
const useHeader_1 = require("../hooks/useHeader");
const index_2 = require("../context/index");
const SCROLL_THRESHOLD = 48;
const Header = ({ headerData, headerElement, dictionary }) => {
    const headerContextValue = (0, useHeader_1.useHeader)({
        headerData,
        headerElement,
        dictionary,
    });
    const isLayoutScroll = (0, app_1.useLayoutScrollDetect)();
    const isLayoutScrollRef = React.useRef(isLayoutScroll);
    const lastScrollYRef = React.useRef(globalThis.scrollY);
    const lastHeaderPositionRef = React.useRef(0);
    const lastHeaderHeightRef = React.useRef(0);
    React.useEffect(() => {
        isLayoutScrollRef.current = isLayoutScroll;
    }, [isLayoutScroll]);
    const setHeaderStyleVariables = React.useCallback(() => {
        const { height, bottom } = headerElement.getBoundingClientRect();
        const flooredBottom = Math.floor(bottom);
        const flooredHeight = Math.floor(height);
        if (lastHeaderPositionRef.current !== flooredBottom) {
            document.body.style.setProperty('--header-position', `${flooredBottom}px`);
            lastHeaderPositionRef.current = flooredBottom;
        }
        if (lastHeaderHeightRef.current !== flooredHeight) {
            document.body.style.setProperty('--header-height', `${flooredHeight}px`);
            lastHeaderHeightRef.current = flooredHeight;
        }
    }, []);
    (0, app_1.useTrackRect)({ target: headerElement, onChange: setHeaderStyleVariables });
    React.useEffect(() => {
        const setHeaderMobileVisibility = () => {
            const currentScrollY = globalThis.scrollY;
            const scrolledPastThreshold = currentScrollY > SCROLL_THRESHOLD;
            const isScrollingDown = currentScrollY > lastScrollYRef.current;
            const isHiddenForMobile = scrolledPastThreshold && isScrollingDown;
            headerElement.classList.toggle('max-md:-translate-y-full', isHiddenForMobile);
            lastScrollYRef.current = currentScrollY;
        };
        const handleScroll = (0, app_1.throttle)(() => {
            // Don't handle scroll when scroll locked and overlay is visible
            if (app_1.overlayService.isOverlayVisible)
                return;
            const isSticky = globalThis.scrollY > SCROLL_THRESHOLD;
            headerElement.classList.toggle('border-b-sm', isSticky);
            headerElement.classList.toggle('md:-translate-y-[44px]', isSticky);
            // Skip mobile header animation during programmatic scrolling or layout transitions
            const shouldSkipHiddenOnMobile = app_1.scrollService.isBusy || isLayoutScrollRef.current;
            if (shouldSkipHiddenOnMobile)
                return;
            setHeaderMobileVisibility();
        });
        setHeaderStyleVariables();
        globalThis.addEventListener('resize', setHeaderStyleVariables, { passive: true });
        globalThis.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            globalThis.removeEventListener('scroll', handleScroll);
            globalThis.removeEventListener('resize', setHeaderStyleVariables);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(index_2.HeaderContext.Provider, { value: headerContextValue, children: [(0, jsx_runtime_1.jsx)(index_1.HeaderOverlay, {}), (0, jsx_runtime_1.jsx)(index_1.HeaderFirstLevel, {}), (0, jsx_runtime_1.jsx)(index_1.HeaderSecondLevel, {})] }));
};
const RenderHeader = ({ headerData, headerElement, dictionary }) => {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(Header, { headerData: headerData, headerElement: headerElement, dictionary: dictionary }), headerElement);
};
exports.RenderHeader = RenderHeader;
